import { createSlice } from "@reduxjs/toolkit";
import {
  AllRackBillsResponse,
  SingleRackResponse,
} from "../../typings/interfaces/responses/rack-response";
import {
  addRackAction,
  deleteRackAction,
  getAllRackBillsAction,
  getallRacksAction,
  getAllRacksAction,
  registerRackBillAction,
  updateRackAction,
} from "../actions/rackAction";
// import { IResponseType } from "../../pages/admin/config/rack-config/rackConfig";
import {
  BaseResponse,
  BaseResponseSingle,
} from "../../typings/interfaces/responses";

export interface RackState {
  addRacks: BaseResponseSingle<SingleRackResponse> | null;
  addRacksLoading: boolean;
  racksError: string | null;

  getRacks: BaseResponse<SingleRackResponse> | null;
  getRacksLoading: boolean;
  getRacksError: string | null;

  registerRackBill: BaseResponseSingle<SingleRackResponse> | null;
  registerRackBillLoading: boolean;
  registerRackBillError: string | null;

  getAllRackBills: BaseResponse<AllRackBillsResponse> | null;
  getAllRackBillsLoading: boolean;
  getAllRackBillsError: string | null;

  getAllRacks: BaseResponse<SingleRackResponse> | null;
  getAllRacksLoading: boolean;
  getAllRacksError: string | null;

  updateRack: BaseResponseSingle<SingleRackResponse> | null;
  updateRackLoading: boolean;
  updateRackError: string | null;
}

const initialState: RackState = {
  addRacks: null,
  addRacksLoading: false,
  racksError: null,

  getRacks: null,
  getRacksLoading: false,
  getRacksError: null,

  registerRackBill: null,
  registerRackBillLoading: false,
  registerRackBillError: null,

  getAllRackBills: null,
  getAllRackBillsLoading: false,
  getAllRackBillsError: null,

  getAllRacks: null,
  getAllRacksLoading: false,
  getAllRacksError: null,

  updateRack: null,
  updateRackLoading: false,
  updateRackError: null,
};

const rackSlice = createSlice({
  name: "rack",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addRackAction.pending, (state) => {
        state.addRacks = null;
        state.addRacksLoading = true;
        state.racksError = null;
      })
      .addCase(addRackAction.fulfilled, (state, action) => {
        state.racksError = null;
        state.addRacksLoading = false;
        state.addRacks = (action.payload as any).body;
      })
      .addCase(addRackAction.rejected, (state, action) => {
        state.addRacks = null;
        state.addRacksLoading = false;
        state.racksError = (action.payload as any).message;
      })

      .addCase(getAllRacksAction.pending, (state) => {
        state.getRacks = null;
        state.getRacksLoading = true;
        state.getRacksError = null;
      })
      .addCase(getAllRacksAction.fulfilled, (state, action) => {
        state.getRacksError = null;
        state.getRacksLoading = false;
        state.getRacks = (action.payload as any).body;
      })
      .addCase(getAllRacksAction.rejected, (state, action) => {
        state.getRacks = null;
        state.getRacksLoading = false;
        state.getRacksError = (action.payload as any).message;
      })

      .addCase(registerRackBillAction.pending, (state) => {
        state.registerRackBill = null;
        state.registerRackBillLoading = true;
        state.registerRackBillError = null;
      })
      .addCase(registerRackBillAction.fulfilled, (state, action) => {
        state.registerRackBillError = null;
        state.registerRackBillLoading = false;
        state.registerRackBill = (action.payload as any).body;
      })
      .addCase(registerRackBillAction.rejected, (state, action) => {
        state.registerRackBill = null;
        state.registerRackBillLoading = false;
        state.registerRackBillError = (action.payload as any).message;
      })

      .addCase(getAllRackBillsAction.pending, (state) => {
        state.getAllRackBills = null;
        state.getAllRackBillsLoading = true;
        state.getAllRackBillsError = null;
      })
      .addCase(getAllRackBillsAction.fulfilled, (state, action) => {
        state.getAllRackBillsError = null;
        state.getAllRackBillsLoading = false;
        state.getAllRackBills = (action.payload as any).body;
      })
      .addCase(getAllRackBillsAction.rejected, (state, action) => {
        state.getAllRackBills = null;
        state.getAllRackBillsLoading = false;
        state.getAllRackBillsError = (action.payload as any).message;
      })
      .addCase(getallRacksAction.pending, (state) => {
        state.getAllRacks = null;
        state.getAllRacksLoading = true;
        state.getAllRacksError = null;
      })
      .addCase(getallRacksAction.fulfilled, (state, action) => {
        state.getAllRacksLoading = false;
        state.getAllRacksError = null;
        state.getAllRacks = action.payload as BaseResponse<SingleRackResponse>;
      })
      .addCase(getallRacksAction.rejected, (state, action) => {
        state.getAllRacksLoading = false;
        state.getAllRacks = null;
        state.getAllRacksError =
          (action.payload as any)?.message || "Failed to fetch all racks.";
      })

      .addCase(updateRackAction.pending, (state) => {
        state.updateRack = null;
        state.updateRackLoading = true;
        state.updateRackError = null;
      })
      .addCase(updateRackAction.fulfilled, (state, action) => {
        state.updateRackLoading = false;
        state.updateRackError = null;
        const body = (action.payload as any).body;
        state.updateRack = body;

        if (state.getAllRacks?.body && Array.isArray(state.getAllRacks.body)) {
          const idx = state.getAllRacks.body.findIndex(
            (r: any) => r.id === body.id
          );
          if (idx !== -1) {
            state.getAllRacks.body[idx] = {
              ...state.getAllRacks.body[idx],
              id: body.id,
              conveyorName: body.convayorName,
              slots: body.slots,
            };
          }
        }
      })
      .addCase(updateRackAction.rejected, (state, action) => {
        state.updateRackLoading = false;
        state.updateRack = null;
        state.updateRackError =
          (action.payload as any)?.message ?? "Update failed";
      })
      .addCase(deleteRackAction.fulfilled, (state, action) => {
        if (state.getAllRacks && Array.isArray(state.getAllRacks.body)) {
          state.getAllRacks.body = state.getAllRacks.body.filter(
            (rack) => rack.id !== action.payload.deletedRackId
          );
        }
      });
  },
});

export default rackSlice.reducer;
export const rackSliceActions = rackSlice.actions;
